export default __webpack_public_path__ + "static/media/tokenomicsElementLeft.f59f9639.png";